import { useLocation, useNavigate } from "react-router-dom";
import MultiPane from "@components/tabs-responsive/tabs-responsive";
import TaskPlans from "./task-plans";
import TaskUsers from "./task-users";
import TaskResources from "./task-resources";

const Tasks = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const items = [
    {
      key: "/tasks",
      label: "Планирование",
      children: <TaskPlans />,
    },
    {
      key: "/tasks/users",
      label: "Исполнители",
      children: <TaskUsers />,
    },
    {
      key: "/tasks/resources",
      label: "Ресурсы",
      children: <TaskResources />,
    },
  ];

  const activeKey = items.find(item => location.pathname === item.key)?.key || items[0].key;

  const onTabChange = (key) => {
    navigate(key);
  };

  return (
    <div className="page">
      <MultiPane
        activeKey={activeKey}
        items={items}
        onChange={onTabChange}
        type="card"
      />
    </div>
  );
};

export default Tasks;